// JS for block-specific behavior only
console.log('res contact form block loaded');